export default __webpack_public_path__ + "static/media/Elizabeth 9781408323847.de78640e.jpg";